<template>
  <div>
    <b-overlay :show="loading">
      <div class="row" style="min-height: 250px">
        <div
          class="col-6 col-xs-6 col-md-3"
          v-for="product in productList"
          :key="product._id"
        >
          <single-product :data="product"></single-product>
        </div>
        <div
          class="col-12 text-center text-muted py-5"
          v-if="!loading && productList.length === 0"
        >
          Aun no hay productos recomendados
        </div>
        <slot></slot>
      </div>
    </b-overlay>
  </div>
</template>

<script>
const singleProduct = () =>
  import(/* webpackChunkName: "singleproduct" */ "../components/singleProduct.vue");

export default {
  components: {
    singleProduct,
  },
  props: ["id", "params"],
  data() {
    return {
      products: [],
      loading: true,
      limit: 4,
    };
  },
  mounted() {
    if (this.params) {
      const params = this.params.split(",");
      params.forEach((element) => {
        const [key, value] = element.split("=");
        if (this[key]) this[key] = value;
      });
    }
    this.load();
  },
  methods: {
    load() {
      const { webName } = this.$store.state.info;
      if (!webName) {
        this.loading = false;
        return;
      }

      this.$http
        .get(`${webName}/product/recomended`)
        .then((res) => {
          this.products = res.data.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    productList() {
      return this.products.slice(0, this.limit);
    },
  },
};
</script>
